import BaseUIStoreSettingPDFShippingLabel from 'xui/modules/print/BaseUIStoreSettingPDFShippingLabel'

export default class StoreSettingPrintingBarcode extends BaseUIStoreSettingPDFShippingLabel {
  static displayName = 'StoreSettingPrintingBarcode'

  static navigationOptions = {
    header: null,
  }
}
